<template>
  <div class="news">
    <div class="news-search">
      <form action="/">
        <van-search
          v-model="keyword"
          placeholder="搜索"
          @search="getArticleList"
        >
          <template #left-icon>
            <img
              src="@/assets/images/search.png"
              alt=""
            />
          </template>
        </van-search>
      </form>
    </div>
    <div
      class="news-list shadow-box content-box"
      v-if="articleList.length > 0"
    >
      <div
        class="news-item"
        v-for="item in articleList"
        :key="item.id"
        @click="goDetail(item)"
      >
        <div class="news-item-left">
          <h3 class="news-title ellipsis-2">
            {{ item.title }}
          </h3>
          <p class="news-sub">{{ item.update_time_show }}</p>
        </div>
        <div class="news-item-right">
          <img
            :src="item.img_url"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="no-data"
      v-else
    >
      <img
        src="@/assets/images/no_data.png"
        alt=""
      />
      <span>暂无搜索结果</span>
    </div>
  </div>
</template>

<script>
import newsService from "@/apis/news/index";
// import { swiper, swiperSlide } from '@/thirdPackages/vue-awesome-swiper'
import "swiper/swiper-bundle.css";
import moment from "moment";

export default {
  data() {
    return {
      topArticleList: {},
      articleList: [],
      keyword: "",
    };
  },
  created() {
    document.title = "健康资讯";
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      const params = {
        page_index: 1,
        page_size: 100,
        keyword: this.keyword,
        category_id: this.$route.params.type,
      };
      newsService.getArticleList(params).then((res) => {
        res.data.forEach((item) => {
          item.update_time_show = moment(item.update_time).format("YYYY-MM");
        });
        this.articleList = res.data;
      });
    },
    goDetail(item) {
      if (!item.content) {
        const params = {
          id: item.id,
        };
        newsService.articleBrowseAddOne(params).then(() => {
          location.href = item.link_url;
        });
      } else {
        this.$router.push({
          name: "NewsDetail",
          params: {
            id: item.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  img {
    width: 261px;
    height: auto;
  }
  span {
    color: #666666;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    margin-top: 20px;
  }
}
.news {
  height: 100%;
  overflow-y: scroll;
}
.news-search {
  img {
    height: 16px;
    width: 16px;
  }
  .van-cell {
    line-height: 30px;
  }
}
.news-main {
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
  .news-title {
    margin: 15px 0 10px 0;
  }
  .news-sub {
    margin: 0;
  }
}
.news-list {
  margin-top: 20px;
  padding: 0 15px;
}
.news-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f6;
  padding: 15px 0;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
}
.news-item-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .news-title {
    line-height: 22px;
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
  }
  .news-sub {
    margin: 0;
    font-size: 11px;
    font-weight: 400;
    color: #999999;
    line-height: 11px;
  }
}
.news-item-right {
  width: 120px;
  height: 80px;
  margin-left: 10px;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
</style>

<style lang="less">
.news-search {
  .van-search__content {
    border-radius: 10px;
  }
}
</style>